var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "select-bar"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchTechnicalService
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-right": "30px"
    },
    attrs: {
      "placeholder": "筛选技术人员",
      "label-in-value": "",
      "multiple": "",
      "filterable": ""
    },
    on: {
      "on-query-change": _vm.getSearchList,
      "on-change": _vm.choseUser
    },
    model: {
      value: _vm.techVisible,
      callback: function ($$v) {
        _vm.techVisible = $$v;
      },
      expression: "techVisible"
    }
  }, _vm._l(_vm.techVisibleMember, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('Select', {
    staticStyle: {
      "width": "200px",
      "margin-right": "30px"
    },
    on: {
      "on-change": _vm.selectStatusMethod
    },
    model: {
      value: _vm.selectStatus,
      callback: function ($$v) {
        _vm.selectStatus = $$v;
      },
      expression: "selectStatus"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('RadioGroup', {
    staticClass: "view-switch",
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": _vm.changeView
    },
    model: {
      value: _vm.view,
      callback: function ($$v) {
        _vm.view = $$v;
      },
      expression: "view"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "list"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-menu"
    }
  })], 1), _c('Radio', {
    attrs: {
      "label": "card"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-grid"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "button-bar"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadTechService
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateTechServiceDrawer();
      }
    }
  }, [_vm._v("新增技术服务")])], 1)]), _vm.view === 'card' ? _c('div', {
    ref: "tableWrapper",
    staticClass: "card-wrapper"
  }, _vm._l(_vm.techServicesList, function (item, parentIndex) {
    return _c('div', {
      key: item._id,
      staticClass: "techService-item",
      attrs: {
        "value": item._id
      }
    }, [_c('List', {
      staticClass: "tech-list",
      attrs: {
        "border": ""
      }
    }, [_c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("阶段")]), _c('div', [_vm._v(_vm._s(_vm.statusToTextMethod(item.status)))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("客户")]), _c('div', [_vm._v(_vm._s(item.customer.name))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("申请人")]), _c('div', [_vm._v(_vm._s(item.createdBy.name))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("创建日期")]), _c('div', [_vm._v(_vm._s(_vm.dayjs(item.createdAt)))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("技术")]), _c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.showSelectPerson(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.techPerson.map(function (x) {
      return x.name;
    }).join("、")) + " ")])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("实验日期")]), _c('div', [_vm._v(_vm._s(_vm.dayjs(item.scheduleTime, "scheduleTime")))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("工单ID")]), _c('div', [_vm._v(_vm._s(item._id))])]), _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("实验结果")]), _c('div', [_vm._v(_vm._s(item.result))])]), item.status === 'verifying' ? _c('ListItem', [_c('div', {
      staticClass: "title",
      staticStyle: {
        "height": "112px",
        "line-height": "88px"
      }
    }, [_vm._v(" 工单审核 ")]), _c('div', {
      staticStyle: {
        "margin": "auto"
      }
    }, [_c('Button', {
      attrs: {
        "type": "primary",
        "ghost": "",
        "size": "large",
        "long": ""
      },
      on: {
        "click": function ($event) {
          return _vm.showModelMethod(item, 'oAr');
        }
      }
    }, [_vm._v("工单+配方通过")]), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "margin-top": "8px",
        "padding": "0"
      }
    }, [_c('Button', {
      attrs: {
        "type": "success",
        "ghost": "",
        "size": "small"
      },
      on: {
        "click": function ($event) {
          return _vm.showModelMethod(item, 'oreder', 'finished');
        }
      }
    }, [_vm._v("工单通过")]), _c('Button', {
      attrs: {
        "type": "error",
        "ghost": "",
        "size": "small"
      },
      on: {
        "click": function ($event) {
          return _vm.showModelMethod(item, 'oreder', 'rejected');
        }
      }
    }, [_vm._v("拒绝")])], 1)], 1)]) : _c('ListItem', [_c('div', {
      staticClass: "title"
    }, [_vm._v("工单审核")]), !['finished', 'canceled', 'rejected'].includes(item.status) ? _c('Button', {
      attrs: {
        "type": "error",
        "ghost": "",
        "size": "small"
      }
    }, [_vm._v("拒绝工单")]) : _vm._e()], 1)], 1), _c('div', {
      staticClass: "action"
    }, [item.status === 'created' || item.showSelectPerson ? _c('div', {
      staticClass: "techPerson-action-wrap"
    }, [_c('h3', {
      staticClass: "action-title"
    }, [_vm._v("指派技术人员")]), _c('div', {
      staticClass: "techPerson-action-contetn"
    }, _vm._l(_vm.techPersonList, function (person, index) {
      return _c('div', {
        key: person._id,
        staticClass: "techPerson",
        style: {
          border: _vm.techServicesList[parentIndex].showFlag.includes(index) ? '1px solid #0FAEFF' : ''
        },
        attrs: {
          "value": person._id
        },
        on: {
          "click": function ($event) {
            return _vm.chooseTechPerson(person, parentIndex, index);
          }
        }
      }, [_vm._v(" " + _vm._s(person.name) + " ")]);
    }), 0), _c('div', {
      staticClass: "action-bottom"
    }, [_c('div', {
      staticClass: "title",
      staticStyle: {
        "padding": "12px",
        "width": "25%"
      }
    }, [_vm._v(" 确定指派 ")]), _c('Button', {
      attrs: {
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function ($event) {
          return _vm.editTechPerson(item);
        }
      }
    }, [_vm._v("确定")])], 1)]) : _vm._e(), _vm._l(item.recipeSales, function (recipe) {
      return item.status !== 'created' ? _c('div', {
        key: recipe._id,
        staticClass: "action-wrap",
        attrs: {
          "value": recipe._id
        }
      }, [_c('h3', {
        staticClass: "action-title"
      }, [_vm._v("配方")]), _c('List', {
        staticClass: "recipe-wrap"
      }, [_c('div', {
        staticClass: "recipe-info"
      }, [_c('ListItem', [_c('div', {
        staticClass: "title"
      }, [_vm._v("配方编号")]), _c('div', [_vm._v("#" + _vm._s(recipe.NoId))])]), _c('ListItem', [_c('div', {
        staticClass: "title"
      }, [_vm._v("创建")]), _c('div', [_vm._v(_vm._s(recipe.NoId))]), _c('div', [_vm._v(_vm._s(_vm.dayjs(recipe.createdAt)))])]), _c('ListItem', {
        staticClass: "verify-item",
        staticStyle: {
          "justify-content": "space-between",
          "border-bottom": "1px solid #e8eaec"
        }
      }, [_c('div', {
        staticClass: "verify",
        staticStyle: {
          "padding": "0"
        }
      }, [_c('div', {
        staticClass: "title",
        staticStyle: {
          "padding": "12px"
        }
      }, [_vm._v("状态")]), _c('div', [_vm._v(_vm._s(_vm.statusToTextMethod(recipe.status)))])]), _c('div', {
        staticClass: "verify",
        staticStyle: {
          "padding": "0"
        }
      }, [_c('div', {
        staticClass: "title",
        staticStyle: {
          "padding": "12px"
        }
      }, [_vm._v("审核人")]), _c('div', [_vm._v(" " + _vm._s(recipe.verifiedBy ? recipe.verifiedBy.name : "") + " ")])])])], 1), _c('ListItem', [_c('div', {
        staticClass: "recipe-content"
      }, [_c('Row', [_c('Col', {
        attrs: {
          "span": "12"
        }
      }, [_vm._v("材料")]), _c('Col', {
        staticStyle: {
          "text-align": "end"
        },
        attrs: {
          "span": "12"
        }
      }, [_vm._v("比例(%)")])], 1), _vm._l(recipe.detail, function (material) {
        return _c('Row', {
          key: material._id,
          staticClass: "material-list",
          attrs: {
            "value": material._id
          }
        }, [_c('Col', {
          attrs: {
            "span": "12"
          }
        }, [_vm._v(_vm._s(material.material.name))]), _c('Col', {
          staticStyle: {
            "text-align": "end"
          },
          attrs: {
            "span": "12"
          }
        }, [_vm._v(_vm._s(material.ratio * 100))])], 1);
      })], 2)]), _c('ListItem', {
        staticClass: "recipe-bottom"
      }, [_c('div', {
        staticClass: "title",
        staticStyle: {
          "padding": "12px"
        }
      }, [_vm._v("配方审核")]), recipe.status === 'reviewing' && !['finished', 'canceled', 'rejected'].includes(item.status) ? _c('div', [_c('Button', {
        attrs: {
          "type": "primary",
          "ghost": ""
        },
        on: {
          "click": function ($event) {
            return _vm.verifiedRecipeMethod(recipe, 'verified', item);
          }
        }
      }, [_vm._v("通过")]), _c('Button', {
        staticStyle: {
          "margin-left": "12px"
        },
        attrs: {
          "type": "error",
          "ghost": ""
        },
        on: {
          "click": function ($event) {
            return _vm.verifiedRecipeMethod(recipe, 'rejected');
          }
        }
      }, [_vm._v("拒绝")])], 1) : _c('div', [_c('div', [_vm._v(_vm._s(_vm.statusToTextMethod(recipe.status)))])])])], 1)], 1) : _vm._e();
    })], 2)], 1);
  }), 0) : _vm._e(), _vm.view === 'list' ? _c('div', {
    ref: "tableWrapper",
    staticClass: "list-wrapeer"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.techServicesList,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Poptip', {
          attrs: {
            "placement": "bottom",
            "word-wrap": "",
            "width": "300",
            "trigger": "hover",
            "content": row.content
          }
        }, [_c('p', {
          staticClass: "content-item"
        }, [_vm._v(_vm._s(row.content))])])];
      }
    }, {
      key: "operate",
      fn: function (_ref2) {
        var row = _ref2.row;
        return (_vm.currentUser.superAdmin || _vm.arrayIntersection(['technologyLead'], _vm.currentUser.simpleRole).length > 0) && row.status === 'verifying' ? [_c('div', {
          staticClass: "pass",
          on: {
            "click": function ($event) {
              return _vm.openVerifiedRecipeModal(row);
            }
          }
        }, [_vm._v("验收订单")])] : undefined;
      }
    }], null, true)
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "title": "审核工单"
    },
    on: {
      "on-ok": _vm.verifyOrder
    },
    model: {
      value: _vm.showVerifyOrderModel,
      callback: function ($$v) {
        _vm.showVerifyOrderModel = $$v;
      },
      expression: "showVerifyOrderModel"
    }
  }, [_c('p', [_vm._v("确定要审核该技术服务工单吗？")])]), _c('Modal', {
    attrs: {
      "title": "验收订单并通过配方"
    },
    on: {
      "on-ok": _vm.verifyOrderAndRecipe
    },
    model: {
      value: _vm.showVerifyOandRModel,
      callback: function ($$v) {
        _vm.showVerifyOandRModel = $$v;
      },
      expression: "showVerifyOandRModel"
    }
  }, [_c('p', [_vm._v("确认验收之后所有未验收的订单会自动验收合格并完成订单")])]), _c('CreateTechService', {
    ref: "CreateTechService"
  }), _c('EditTechService', {
    ref: "EditTechService"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }